import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule} from '@angular/common/http';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PanelComponent } from './panel/panel.compent';
import { WarningComponent } from './warning/warning.component';
import { TicketComponent } from './ticket/ticket.component';
import { TicketListComponent } from './ticket-list/ticket-list.component';
import { WarningListComponent } from './warning/warning-list/warning-list.component';
import { NewsComponent } from './news/news.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { CarouselComponent } from './carousel/carousel.component';
import { UnsubComponent } from './unsub/unsub.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UnsubDetailsComponent } from './unsub/unsub-details.component';
import { UnsubFormComponent } from './unsub/unsub-form.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PanelComponent,
    WarningComponent,
    TicketComponent,
    TicketListComponent,
    WarningListComponent,
    NewsComponent,
    ChatbotComponent,
    CarouselComponent,
    UnsubComponent,
    UnsubDetailsComponent,
    UnsubFormComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: 'about', component: WarningComponent },
      { path: 'unsubs/new', component: UnsubFormComponent },
      { path: 'unsubs', component: UnsubComponent },
      { path: 'unsubs/:id', component: UnsubDetailsComponent },
      { path: '**', component: WarningComponent }
    ],{ useHash: true })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
